import type { AgendaItem } from '@/store/modules/event/types';

export function sortAgendaItems(agendaItems: AgendaItem[]) {
  const results = agendaItems.sort((a, b) => {
    const timeDiff = Date.parse(a.start_time) - Date.parse(b.start_time);
    if (timeDiff !== 0) {
      return timeDiff;
    }

    if ('created_at' in a && 'created_at' in b && a.created_at && b.created_at) {
      return Date.parse(a.created_at as string) - Date.parse(b.created_at as string);
    }

    return 0;
  });
  return results;
}
